import EventEmitter from 'eventemitter3';
import {CXF} from '../../typings/cxf';

type Params = {
    gameId: string | null;
    instanceId: string | null;
    language: string | null;
    networkId: string | null;
    playerId: string | null;
    zoneId: string | null;
};

export class CxfStub extends EventEmitter implements CXF {
    public gameId: number;
    public instanceId: number;
    public language: string;
    public networkId: number;
    public playerId: number;
    public zoneId: number;

    constructor(params: Params) {
        super();

        const {gameId, playerId, networkId, language, instanceId, zoneId} = params;
        this.gameId = parseInt(gameId as string, 10);
        this.instanceId = parseInt(instanceId as string, 10);
        this.language = language as string;
        this.networkId = parseInt(networkId as string, 10);
        this.playerId = parseInt(playerId as string, 10);
        this.zoneId = parseInt(zoneId as string, 10);
    }

    public appendHtmlTagFor(url: string): HTMLElement {
        const iframe = document.createElement('div');
        iframe.className = 'content';
        iframe.innerText = url;
        document.body.appendChild(iframe);
        return iframe;
    }
}
